import React, { useState } from "react";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";

import { CustomButton, CustomDialog, CustomSelect, FeaturedIcon, FormElement, FormikTextField, MultiSelect } from "../../components";

import css from "./modals.module.css";
// import { useMutation } from "../../../hooks/use-mutation";
// import RebatesClient from "../../../RebatesClient";
import { useMutation } from "../../hooks/use-mutation";
import RebatesClient from "../../RebatesClient";
import FarmSelector from "../../components/filters/farmSelector";
import useFarms from "../../hooks/use-farms";
import useStrategicAccounts from "../../hooks/use-strategic-accounts";
// import { FeaturedIcon } from "../../components";

const DealerFarmModal = ({
  open,
  onClose,
  farm_to_dealer,
  dealer
}) => {

  const isExisting = farm_to_dealer?.farm_to_dealer_id ? true : false
  const { farms } = useFarms();
  const { strategicAccounts } = useStrategicAccounts();
  const [selectedFarms, setSelectedFarms] = useState([])

  const { mutateAsync: submitRequest, isLoading, } = useMutation({
    mutationKey: "saveDealerFarms",
    networkMode: "always",
    mutationFn: async () => isExisting ? await RebatesClient.deleteDealerFarm({farm_to_dealer_id: farm_to_dealer.farm_to_dealer_id}) : await RebatesClient.saveDealerFarms({dealer_id: dealer.id, farm_account_ids: selectedFarms.map(f => f.id)}),
    onError: (err) => { console.log(err) },
    onSuccess: (resp) => {
      if (resp.response.status == 200) {
        onClose()
      }
      else {
        alert(`${resp.body.status}`)
      }

    }
  });


  // const validationSchema = Yup.object({
  // });

  const formik = useFormik({
    initialValues: {},
    validationSchema: null,
    onSubmit: submitRequest
  });

  function handleSelect(event) {
    // setRebateChanged(activeRebateLevel?.id != event.target.value)
    console.log(event)
    setSelectedFarms(event)
    // formik.handleChange(event)
  }

  const title = (
    <div className={css.modalTitle}>
      <FeaturedIcon icon={isExisting ? 'Edit' : 'Plus'} />
      {isExisting ? '' : 'Add Farm(s)'}
    </div>
  );

  const btnClose = (
    <CustomButton
      label="Close"
      onClick={onClose}
      color="secondary"
    />
  );
  const btnSubmit = (
    <CustomButton
      label={isExisting ? "Remove Farm" : "Save"}
      color={isExisting ? "danger" : !selectedFarms.length ? "secondary" : "primary"}
      disabled={!isExisting && !selectedFarms.length}
      onClick={formik.handleSubmit}
    />
  );

  const actions = [btnClose, btnSubmit];

  return (
    <CustomDialog open={open} onClose={onClose} width={640} title={title} actions={actions}>
      <FormikProvider value={formik}>
        <Form className={css.modalForm}>
          {!isExisting &&
            <FarmSelector
              farms={farms?.filter(farm => !dealer?.farms?.some(df => df.id === farm.id)) || []}
              strategicAccounts={strategicAccounts}
              selectedFarms={selectedFarms}
              setSelectedFarms={handleSelect}
              multiFarmSelect={true} />
          }

          {/* {isExisting ? `Do you want to remove the farm ${farm_to_dealer.name} from ${dealer?.name}?` : ''} */}
          {farm_to_dealer.name}
        </Form>
      </FormikProvider>
    </CustomDialog>
  );
};

export default DealerFarmModal;
